import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'gatsby';
import {cx} from '@emotion/css';

import LogoutButton from '@fo/designSystem/Buttons/Logout/LogoutButton';
import {ButtonVariant} from '@fo/designSystem/Buttons/Button/Button';
import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';
import {ReactComponent as AccountIcon} from '@fo/shared-images/icons/account.svg';
import {ReactComponent as ClipboardIcon} from '@fo/shared-images/icons/clipboard.svg';

import styles from './CurrentUserMenu.styles';

type TCurrentUserMenu = {
  isAuthenticatedPage?: boolean;
};

function CurrentUserMenu({isAuthenticatedPage}: TCurrentUserMenu): ReactElement {
  return (
    <>
      <Link
        to={getPageRoute('dashboard.home')}
        className={cx(styles.item, 'unstyledLink')}
        data-testid="control.currentUserMenu.dashboard"
        onClick={() => {
          track(segmentEvents.navigation.userMenu.dashboard);
        }}
      >
        <ClipboardIcon className={cx(styles.icon)} />
        <FormattedMessage id="phoenix.nav.dashboard.linkText" />
      </Link>
      <Link
        to={getPageRoute('dashboard.accountDetails')}
        className={cx(styles.item, 'unstyledLink')}
        data-testid="control.currentUserMenu.accountDetails"
        onClick={() => {
          track(segmentEvents.navigation.userMenu.accountDetails);
        }}
      >
        <AccountIcon className={cx(styles.icon)} />
        <FormattedMessage id="phoenix.nav.accountDetails.linkText" />
      </Link>
      <LogoutButton
        className={cx(styles.item)}
        iconClassName={cx(styles.icon)}
        buttonVariant={ButtonVariant.DEFAULT_TEXT}
        showIcon
        isAuthenticatedPage={isAuthenticatedPage}
      />
    </>
  );
}

export default CurrentUserMenu;
